import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import {
  search,
  loadData,
  updateData,
  updateCellValue,
  closeEditor,
} from "ka-table/actionCreators";
import { SortingMode, PagingPosition } from "ka-table/enums";
import stockService from "../services/stock-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import facilityService from "../services/facility-service";
const tablePropsInit = {
  columns: [
    { key: "drg_name", title: "Drug" },
    { key: "drg_type", title: "Drug Type" },
    { key: "Actions" },
    { key: "Doctor" },
    { key: "display_name", style: { display: "none" } },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInit1 = {
  columns: [
    { key: "drg_name", title: "Drug" },
    { key: "drg_type", title: "Drug Type" },
    { key: "docName", title: "Doctor" },
    { key: "qnty", title: "Quantity" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const StockOrder = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [showDrugList, setShowDrugList] = useState(false);
  const [facList, setFacList] = useState([]);
  const [selectedFac, setSelectedFac] = useState(0);
  const [drugList, setDrugsList] = useState([]);
  const [getQtyRec, setQtyRec] = useState([]);
  const [showAll, setShowAll] = useState(true);
  const [docList, setDoclist] = useState([]);
  const [disable, setDisable] = React.useState(false);
  const { register, setValue } = useForm({});
  const CustomCell = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    return (
      <div>
        <span className="inline-block">
          <input
            type="number"
            min="1"
            autoComplete="off"
            id={"qty" + rowData.id}
            name="qty"
            defaultValue={value}
            placeholder="Quantity"
            onBlur={(e) => {
              if (e.currentTarget.value > 0) {
                dispatch(
                  updateCellValue(
                    rowKeyValue,
                    column.key,
                    e.currentTarget.value
                  )
                );
                let idx = getQtyRec.findIndex((elem) => elem.id === rowData.id);
                if (idx > -1) {
                  getQtyRec[idx].qnty = e.currentTarget.value;
                  setQtyRec(getQtyRec);
                } else {
                  let idx1 = drugList.findIndex(
                    (elem) => elem.id === rowData.id
                  );
                  drugList[idx1].qnty = e.currentTarget.value;
                  setQtyRec([...getQtyRec, drugList[idx1]]);
                }
              } else {
                let idx = getQtyRec.findIndex((elem) => elem.id === rowData.id);
                if (idx > -1) {
                  getQtyRec[idx].qnty = 0;
                  setQtyRec(getQtyRec);
                }
              }
            }}
            className="border focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-full"
          />
        </span>
      </div>
    );
  };

  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [tableProps1, changeTableProps1] = useState(tablePropsInit1);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
  };
  const dispatch1 = async (action) => {
    changeTableProps1((prevState) => kaReducer(prevState, action));
  };
  const getExistFacs = async () => {
    try {
      setLoading(true);
      let resp = await facilityService.getFacilities();
      if (resp) {
        setFacList(resp);
        if (resp.length === 1) {
          setValue("facility", resp[0].id);
          getExistingDrugs(resp[0].id);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  async function getExistingDrugs(facility) {
    if (facility > 0) {
      try {
        setLoading(true);
        setQtyRec([]);
        let resp = await stockService.getMasterDrugList("", facility);
        if (resp?.drugs.length > 0) {
          if (resp.doctors.length > 0) {
            resp.drugs.sort((a, b) =>
              (a.display_name ? a.display_name : a.drg_name).localeCompare(
                b.display_name ? b.display_name : b.drg_name
              )
            );
            let finalResult = resp.drugs.map((e) => ({
              ...e,
              docId: resp.doctors[0].id,
              docName: resp.doctors[0].name,
              qnty: 0,
            }));
            setShowAll(true);
            setDrugsList(finalResult);
            resp?.doctors.sort((a, b) => a.code.localeCompare(b.code));
            setDoclist(resp?.doctors);
            dispatch(updateData(finalResult));
            setShowDrugList(true);
          } else {
            setDrugsList([]);
            setDoclist([]);
            dispatch(updateData([]));
            setShowDrugList(false);
            const { hide } = cogoToast.error(
              "Please ask pharmacy to assign doctor for this facility",
              {
                hideAfter: 15,
                onClick: () => {
                  hide();
                },
              }
            );
          }
        } else {
          setDrugsList([]);
          setDoclist([]);
          dispatch(updateData([]));
          setShowDrugList(false);
          const { hide } = cogoToast.error("No Records Found!", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
        }
        setSelectedFac(facility);
        setLoading(false);
      } catch (e) {
        setShowDrugList(false);
        const { hide } = cogoToast.error(
          "Error retrieving Master Drugs List. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    } else {
      setShowDrugList(false);
    }
  }
  const CustomCell2 = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    let strngth = rowData.strength ? "-" + rowData.strength : "";
    let dosId = rowData.dos_id ? "-" + rowData.dos_id : "";
    return (
      <div>
        <span className="inline-block">
          {rowData.display_name
            ? rowData.display_name
            : rowData.drg_name + strngth + dosId}
        </span>
      </div>
    );
  };
  const CustomCell3 = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    return (
      <div>
        <span className="inline-block">
          {rowData.drg_type ? rowData.drg_type.replace("_", " ") : ""}
        </span>
      </div>
    );
  };
  const CustomCell4 = ({
    column,
    rowKeyValue,
    dispatch,
    value,
    rowData,
    ...rest
  }) => {
    const close = () => {
      dispatch(closeEditor(rowKeyValue, column.key));
    };
    const [editorValue, setValue] = useState(value);
    return (
      <div className="grid">
        <span className="inline-block">
          <select
            id={"drgType" + rowData.id}
            defaultValue={editorValue}
            onChange={async (e) => {
              setValue(e.currentTarget.value);
              if (e.currentTarget.value !== "") {
                dispatch(
                  updateCellValue(
                    rowKeyValue,
                    column.key,
                    e.currentTarget.value
                  )
                );
                let idx = getQtyRec.findIndex((elem) => elem.id === rowData.id);
                if (idx > -1) {
                  getQtyRec[idx].docId = e.currentTarget.value;
                  getQtyRec[idx].docName =
                    e.currentTarget.options[e.currentTarget.selectedIndex].text;
                  setQtyRec(getQtyRec);
                } else {
                  let idx1 = drugList.findIndex(
                    (elem) => elem.id === rowData.id
                  );
                  drugList[idx1].docId = e.currentTarget.value;
                  drugList[idx1].docName =
                    e.currentTarget.options[e.currentTarget.selectedIndex].text;
                  setQtyRec([...getQtyRec, drugList[idx1]]);
                }
              }
              close();
            }}
            className="border focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-full"
          >
            {docList
              ? docList.map((doctor, i) => {
                  return (
                    <option key={i} value={doctor.id}>
                      {doctor.name}
                    </option>
                  );
                })
              : null}
          </select>
        </span>
      </div>
    );
  };
  async function cancelSelection() {
    setShowAll(true);
  }
  async function submitQty() {
    let subRec = [];
    if (getQtyRec.length > 0) {
      getQtyRec.map((rec, i) => {
        subRec.push({
          stock_id: rec.id,
          fac_id: selectedFac,
          quantity: rec.qnty,
          doc_id: rec.docId,
        });
        return true;
      });
    }
    if (subRec.length > 0) {
      try {
        setLoading(true);
        let resp = await stockService.saveQuantity(subRec);
        if (resp) {
          const { hide } = cogoToast.success(
            "Stock Order(s) Placed Successfully!",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        } else {
          const { hide } = cogoToast.error(
            "Error while adding...Please try after sometime.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        }
        setLoading(false);
        await history.push("/stocksReports");
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error while inserting quantity for drugs. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    }
  }
  async function saveQty() {
    let saveRecords = getQtyRec.filter((res) => res.qnty > 0);
    if (saveRecords.length > 0) {
      setQtyRec(saveRecords);
      dispatch1(updateData(saveRecords));
      setShowAll(false);
    } else {
      const { hide } = cogoToast.error(
        "Please add quantity for atleast one drug .",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  }
  useEffect(() => {
    getExistFacs();
  }, []);
  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 w=full">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl"> STOCK ORDER FORM</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <ul className="">
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <label className="text-labelclr font-semibold text-sm tracking-wider">Facility</label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="facility"
                aria-label="Select Facility"
                ref={register({
                  required: false,
                })}
                onChange={(e) => {
                  getExistingDrugs(e.target.value);
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="0">Select Facility</option>
                {facList
                  ? facList.map((facility, i) => {
                      return (
                        <option key={i} value={facility.id}>
                          {facility.name}
                        </option>
                      );
                    })
                  : null}
              </select>
              <p className="mt-4 inline-block font-base">
                <span className="text-hlred ">Note : </span>
                The Provider defaulting for the stock order is the main
                provider. If stock is ordered by other provider, please select
                the provider from the dropdown next to the order.
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div
        className={`bg-white w-11/12 sm:w-2/4 mx-auto mt-2 mb-4 ${
          showDrugList ? "show" : "hidden"
        }`}
      >
        <div
          className={`text-xs stockOrderList ${
            showAll ? "show" : "hidden"
          }`}
        >
          <div className="w-full text-right">
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom mt-3"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 right-5 -top-2 bottom-3"
              ></img>
            </span>
          </div>
          <div className="p-2 text-xs gridList overflow-x-auto">
            <Table
              {...tableProps}
              childComponents={{
                cellText: {
                  content: (props) => {
                    // eslint-disable-next-line default-case
                    switch (props.column.key) {
                      case "drg_name":
                        return <CustomCell2 {...props} />;
                      case "drg_type":
                        return <CustomCell3 {...props} />;
                      case "Actions":
                        return <CustomCell {...props} />;
                      case "Doctor":
                        return <CustomCell4 {...props} />;
                    }
                  },
                },
              }}
              dispatch={dispatch}
            />
            <div className="w-full inline-block">
              <input
                type="button"
                onClick={() => {
                  saveQty();
                }}
                value="Save"
                className=" bg-header_bg rounded py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6
                float-right mr-1"
              />
            </div>
          </div>
        </div>
        <div
          className={`pb-5 text-xs selectedStkList gridList ${
            showAll ? "hidden" : "show"
          }`}
        >
          <div className="p-2 text-xs gridList overflow-x-auto">
          <Table
            {...tableProps1}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "drg_name":
                      return <CustomCell2 {...props} />;
                    case "drg_type":
                      return <CustomCell3 {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch1}
          />
          </div>
          <div className="w-full mb-2 inline-block">
            <input
              type="button"
              onClick={() => {
                cancelSelection();
              }}
              value="Cancel"
              className="text-white w-full sm:w-auto h-8 px-6 
              bg-header_bg rounded text-xs font-medium capitalize 
              focus:outline-none float-right inline-block mr-4"
            />
            <input
              type="button"
              onClick={() => {
                setDisable(true);
                submitQty();
              }}
              disabled={disable}
              value="Submit"
              className={`text-white w-full sm:w-auto h-8 px-6 
              bg-header_bg rounded text-xs font-medium capitalize 
              focus:outline-none float-right inline-block mr-4 ${
                disable ? "cursor-not-allowed" : ""
              }`}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(StockOrder)
);
